
import Vue from 'vue';
import { IconButton, WhatsNewTag } from '@descomplica/vue-components';
import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';
import { Period } from '@/store/modules/periods/state';
import CourseHeaderSkeleton from '@/components/skeletons/CourseHeaderSkeleton.vue';

interface Data {
  seenUndergradStudyPlan: boolean;
}

export default Vue.extend({
  components: {
    IconButton,
    CourseHeaderSkeleton,
    WhatsNewTag,
  },
  props: {
    currentPeriod: {
      type: Object as Vue.PropType<Period>,
      default: null,
    },
  },
  data(): Data {
    return {
      seenUndergradStudyPlan: !!localStorage.getItem('seenUndergradStudyPlan'),
    };
  },
  computed: {
    shouldShowPeriodSelectBox(): boolean {
      if (this.$route.params.category === 'pos') return false;
      return true;
    },
    periodSubtitle(): TranslateResult {
      if (this.shouldDisplayPeriodsRenamed) {
        return i18n.t('modules');
      }

      return i18n.t('periods');
    },
    studyPlanSubtitle(): TranslateResult {
      return i18n.t('undergradStudyPlan');
    },
    whatsNewText(): TranslateResult {
      return i18n.t('whatsNewTag');
    },
    title(): TranslateResult {
      return this.shouldShowPeriodSelectBox ? this.currentPeriod.name : `${i18n.t('subjects')}`;
    },
    isLoadingPeriod(): boolean {
      return this.$store.getters.isLoadingPeriod;
    },
    canViewUndergradStudyPlan(): boolean {
      return this.hasStudyPlanToDisplay && this.isUndergraduateCourse;
    },
    hasStudyPlanToDisplay(): boolean {
      return this.$store.getters.currentStudyPlanId > 0;
    },
    isUndergraduateCourse(): boolean {
      return this.$store.getters.isUndergraduateCourse;
    },
    shouldDisplayPeriodsRenamed(): boolean {
      return this.$store.getters.shouldDisplayPeriodsRenamed;
    },
  },
  methods: {
    openMenu() {
      this.$emit('openMenu');
    },
    openStudyPlan() {
      this.$emit('openStudyPlan');
    },
    closeWhatsNewTag() {
      localStorage.setItem('seenUndergradStudyPlan', 'true');
      this.seenUndergradStudyPlan = true;
    },
  },
});
